<template>
    <SideHeader :indexPage="true" />
    <div id="appCapsule">
        <div id="loader" v-if="loading">
            <div class="spinner-border text-primary" role="status"></div>
        </div>
        <div v-else>
            <div class="bg-white">
                <div style="height:128px">

                    <Map :LatLngFirst="[path.fromLatLong.latitude, path.fromLatLong.longitude]"
                        :centerValue="[(+path.fromLatLong.latitude + +path.toLatLong.latitude) / 2, (+path.fromLatLong.longitude + +path.toLatLong.longitude) / 2]"
                        :latLngSecond="[path.toLatLong.latitude, path.toLatLong.longitude]"
                        :latLngs="[[path.fromLatLong.latitude, path.fromLatLong.longitude], [path.toLatLong.latitude, path.toLatLong.longitude]]"
                        :distance="cargo.distanceCity" />
                    <div class="routing">
                        <a href="#" type="button" class="btn background-locate text-locate p-1"
                            data-bs-toggle="offcanvas" :data-bs-target="'#actionSheetIconed_' + loadId"
                            @click="offClose()">
                            مسیریابی روی نقشه
                            <ion-icon role="img" class="md hydrated" style="margin-left: 0;"
                                name="chevron-forward-outline"></ion-icon>
                        </a>
                        <Routing :cargo="loadId" :fromLat="path.fromLatLong.latitude"
                            :fromLong="path.fromLatLong.longitude" :toLat="path.toLatLong.latitude"
                            :toLong="path.toLatLong.longitude" />
                    </div>
                </div>
                <div class="m-2">
                    <!-- <div class="chip chip-media my-2">
                        <ion-icon name="calendar-outline"></ion-icon>
                        <span class="chip-label">{{ cargo.loadingDate }}</span>
                    </div> -->
                    <div class="card-body py-0">
                        <WithoutPrice :distanceCity="this.cargo.distanceCity" :distanct="this.cargo.distanct"
                            :fromCity="this.cargo.fromCity" :toCity="this.cargo.toCity" />
                    </div>
                    <PaymentBox :cargo="cargo" />
                    <div class="return-loads-wrapper">

                        <!-- <div class="return-loads-text">
                            <button type="button" class="btn btn-link load-back p-0" data-bs-toggle="offcanvas"
                                @click="getDetailLoad" :data-bs-target="'#cargoDetail' + loadId">
                                مشاهده جزئیات بار
                                <ion-icon role="img" class="md hydrated" style="font-size: 15px;"
                                    name="chevron-forward-outline"></ion-icon>
                            </button>
                        </div> -->

                        <div class="return-loads-text">
                            <a class="btn btn-link load-back p-0"
                                :href="'/returnLoads/' + cargo.destination_city_id">مشاهده بارهای
                                مقصد
                                <ion-icon role="img" class="md hydrated" name="chevron-forward-outline"
                                    style="font-size:15px; padding-top: 2px;"></ion-icon>
                            </a>
                        </div>
                    </div>
                    <div class="section full mt-1 pb-7">
                        <ul class="nav nav-tabs lined border-gray" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="tab" :href="'#cargo' + loadId" role="tab">
                                    اطلاعات بار
                                </a>
                            </li>
                            <li class="nav-item" v-show="owner != null && owner?.isAccepted == 1">
                                <a class="nav-link" data-bs-toggle="tab" :href="'#owner' + loadId" role="tab">
                                    صاحب بار
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content mt-2">
                            <div class="tab-pane fade show active" :id="'cargo' + loadId" role="tabpanel">
                                <LoadInfo :cargo="cargo" :owner="owner" />
                                <div class="return-loads-wrapper">
                                    <div class="return-loads-text">
                                        <button type="button" class="btn btn-link load-back p-0"
                                            data-bs-toggle="offcanvas" @click="getDetailLoad"
                                            :data-bs-target="'#cargoDetail' + loadId">
                                            مشاهده جزئیات بار
                                            <ion-icon role="img" class="md hydrated"
                                                style="font-size: 15px; padding-top: 6px;"
                                                name="chevron-forward-outline"></ion-icon>
                                        </button>
                                    </div>
                                </div>

                                <AlertDriver :loadId="loadId" />
                            </div>
                            <div class="tab-pane fade" :id="'owner' + loadId" role="tabpanel">
                                <div class="text-center mb-2">
                                    <div class="avatar">
                                        <img src="assets/img/sample/avatar/Untitled-1.png" alt="avatar"
                                            class="imaged w64 rounded" />
                                    </div>
                                    <!-- <p class="fw-bolder my-1">{{ owner?.name + ' ' + owner?.lastName }}</p> -->
                                    <div class="my-1" style="display:inline-block;"
                                        v-if="owner?.ratingOwner != null && owner?.isAccepted == 1">
                                        <star-rating :inline="true" :star-size="16" :read-only="true"
                                            :show-rating="false" :rating="owner.ratingOwner"></star-rating>
                                    </div>
                                    <div v-if="owner?.ratingOwner == null && owner?.isAccepted == 1" class="my-1">
                                        <star-rating :inline="true" :star-size="16" :read-only="true"
                                            :show-rating="false" :rating="5"></star-rating>
                                    </div>
                                    <p class="text-TEAL owner-title" v-if="owner?.isAccepted == 1">تایید شده</p>
                                    <hr class="m-0" />
                                    <div class="return-loads-wrapper">
                                        <div class="return-loads-text">
                                            <button type="button" class="btn btn-link load-back p-0"
                                                data-bs-toggle="offcanvas" @click="getDetailLoad"
                                                :data-bs-target="'#cargoDetail' + loadId">
                                                مشاهده جزئیات بار
                                                <ion-icon role="img" class="md hydrated"
                                                    style="font-size: 15px; padding-top: 6px;"
                                                    name="chevron-forward-outline"></ion-icon>
                                            </button>
                                        </div>

                                    </div>

                                </div>
                                <AlertDriver :loadId="loadId" />

                            </div>
                            <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1"
                                :id="'cargoDetail' + loadId">
                                <div class="offcanvas-header">
                                    <h5 class="offcanvas-title">جزئیات بیشتر</h5>
                                </div>
                                <div class="offcanvas-body">
                                    <PlaceholderLine v-if="loading == 1" />
                                    <Optional :loadId="loadId" :optional="optional" :cargo="cargo" v-else />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="footer-position px-3" id="footer">
                    <div class="row my-2 g-1">
                        <div class="col">

                            <button v-if="loadingCall == 0" type="button" @click.prevent="callToOwner"
                                class="btn background-ORANGE btn-block text-light btn-block" style="height: 3rem">
                                <ion-icon name="call-outline" role="img" class="md hydrated"
                                    aria-label="logo dropbox"></ion-icon>
                                تماس با صاحب بار
                            </button>

                            <button v-else class="btn background-ORANGE text-light btn-block" type="button" disabled="">
                                <span class="spinner-border spinner-border-sm me-05" role="status"
                                    aria-hidden="true"></span>
                                درحال بارگذاری ...
                            </button>

                            <button style="display: none" :id="'pardakht_' + loadId" type="button"
                                class="btn background-ORANGE text-light btn-block" @click="offPardakht"
                                data-bs-toggle="offcanvas" :data-bs-target="'#actionSheetContent_' + loadId">
                                <ion-icon name="call-outline" role="img" class="md hydrated"
                                    aria-label="logo dropbox"></ion-icon>
                                پرداخت
                            </button>
                            <a class="d-none" :href="'tel:' + cargo.mobileNumberForCoordination"
                                :id="cargo.mobileNumberForCoordination">
                            </a>
                            <Peyment :driver_id="idUser" :data="loadId" />
                        </div>
                    </div>
                    <div class="row g-1">
                        <div class="col" v-if="cargo.userType == 'owner' && statusAcceptCargo == 0 && accept == 0">

                            <button class="btn btn-acceptCargo btn-block" type="button" :disabled="loadAccept == 1"
                                @click.prevent="submitCargo()">
                                <span v-if="loadAccept == 1" class="spinner-border spinner-border-sm me-05"
                                    role="status" aria-hidden="true"></span>
                                <ion-icon v-else name="checkmark-outline" role="img" class="md hydrated"
                                    aria-label="logo dropbox"></ion-icon>
                                {{ loadAccept == 1 ? 'درحال بارگذاری ...' : 'پذیرش حمل بار' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import delivery_methods from "@/delivery_methods";
import WithoutPrice from "@/components/fromToCity/WithoutPrice.vue";
// import Placeholder from "@/components/Placeholder.vue";
import PaymentBox from "@/components/PaymentBox.vue";
import LoadInfo from "./components/LoadInfo.vue";
import PlaceholderLine from "@/components/Placeholder/Line.vue"
import Optional from '@/views/cargo/components/Optional.vue'
import AlertDriver from "@/components/AlertDriver.vue";
import StarRating from 'vue-star-rating'
import Swal from "sweetalert2";
import SideHeader from "@/components/SideHeader.vue";
import Routing from "./components/Routing.vue";
import Map from '@/components/Map.vue';
import Peyment from "@/components/Peyment.vue";
export default {
    components: {
        // Placeholder,
        WithoutPrice,
        PaymentBox,
        LoadInfo,
        PlaceholderLine,
        Optional,
        AlertDriver,
        StarRating,
        SideHeader,
        Routing,
        Map,
        Peyment
    },
    data() {
        return {
            loadId: this.$route.params.load,
            idUser: window.localStorage.getItem("idUser"),
            cargo: '',
            owner: '',
            loading: false,
            optional: [],
            path: '',
            loadAccept: 0,
            accept: 0,
            statusAcceptCargo: 0,
            loadingCall: 0,
            axiosConfig: {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                    Accept: "application/json",
                },
            },
        };
    },
    methods: {
        getDetail() {
            this.loading = true;
            axios.get(`${delivery_methods.BASE_URL}api/driver/loadDetail/${this.loadId}`, this.axiosConfig)
                .then((res) => {
                    this.statusAcceptCargo = res.data.result;
                    this.loading = false;
                    this.cargo = res.data.loadInfo;
                    this.owner = res.data.owner;
                    this.path = res.data.path;
                })
                .catch((error) => {
                    window.history.go(-1); return false;
                    // Swal.fire({
                    //     title: `بار`,
                    //     text: "بار مورد نظر حذف شد!",
                    //     icon: "error",
                    //     showCancelButton: false,
                    //     confirmButtonColor: "#0EA47A",
                    //     confirmButtonText: "حله",
                    // }).then((result) => {
                    //     if (result.isConfirmed) {
                    //         window.history.go(-1); return false;
                    //     }
                    // }).finally((res) =>{
                    //     alert(res)
                    // });
                });
        },
        offClose() {
            localStorage.setItem("offClose", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?offClose=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        },
        callToOwner() {
            // console.log(this.idUser);
            this.loadingCall = 1;
            axios.get(`${delivery_methods.BASE_URL}api/driver/checkDriverStatusForCalling/${this.cargo.mobileNumberForCoordination}/${this.loadId}/${window.localStorage.getItem("latitude")}/${window.localStorage.getItem("longitude")}`, this.axiosConfig)
                .then((res) => {
                    // console.log(res);
                    if (res.data.result == 1 || res.data.result == true) {
                        // this.pardakht = 1;
                        window.location = document.getElementById(this.cargo.mobileNumberForCoordination).href;
                    }
                    else if (res.data.result == false) {
                        // console.log(window.localStorage.getItem("closeId"));
                        // console.log("pardakht_" + window.localStorage.getItem("closeId"));
                        document.getElementById("pardakht_" + this.loadId).click();
                    }
                    else if (res.data.result == 2) {
                        Swal.fire({
                            position: "center",
                            icon: "warning",
                            title: "آگهی منقضی شده است",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                    // callStatus.value = response.data;
                })
                .catch(function (error) {
                    setTimeout(() => {
                        this.loading = 0;
                    }, 5000);
                    // handle error
                    console.log(error);
                }).finally(() => {
                    this.loadingCall = 0
                });
        },
        submitCargo() {
            this.loadAccept = 1;
            axios.post("https://core.iran-tarabar.ir/api/driver/storeInquiryToLoad", {
                load_id: this.loadId,
                price: this.cargo.suggestedPrice == null ? 0 : this.cargo.suggestedPrice,
                latitude: window.localStorage.getItem("latitude"),
                longitude: window.localStorage.getItem("longitude")
                // city: window.localStorage.getItem("city"),
            }, this.axiosConfig)
                .then((res) => {
                    if (res.data.result == 1) {
                        this.loadAccept = 0;
                        this.accept = 1;
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "درخواست شما با موفقیت ثبت شد",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                    else {
                        Swal.fire({
                            position: "top-end",
                            icon: "error",
                            title: "شما به محدودیت تماس رسیده اید",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                        document.getElementById("pardakht").click();
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });
        },
        getDetailLoad() {
            localStorage.setItem("openDetailLoad", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?openDetailLoad=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        },
        offPardakht() {
            localStorage.setItem("offPardakht", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname + "?offPardakht=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        }
    },
    created() {
        this.getDetail();
    }
};
</script>

<style scoped>
.leaflet-container {
    z-index: 0 !important;
}

.appBottomMenu {
    display: none !important;
}



.routing {
    position: absolute;
    top: 140px;
    left: 1rem;
    /* z-index: 999; */
}

.background-locate {
    background-color: #FFFFFFCC !important;
}

.text-locate {
    color: #068B80 !important;
}

.owner-title {
    margin-top: 10px;
    font-weight: 700;
}


.return-loads-wrapper {
    align-self: center;
    display: flex;
    font-size: 13px;
    padding: 4px 4px;
    float: left;
}

#footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 20px;
}

.return-loads-icon {
    /* aspect-ratio: 1; */
    object-fit: auto;
    object-position: center;
    width: 16px;
    margin: auto 0;
}

.return-loads-text {
    font-family: IRANSansXFaNum, sans-serif;
}

.space_detail {
    border-bottom: 1px dashed #e6e6e6;
    padding-bottom: 5px;
}

.footer-position {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
}

.load-back {
    float: left;
    color: var(--Primery, #068b80);
    font-weight: 500
}

.border-gray {
    border-bottom: 1px solid #d9d9d9;
}

.btn-acceptCargo {
    color: #0EA47A !important;
    background: #fff;
    border: 1px solid;
}
</style>